<div class="terra-form-field-wrapper state-field">
    <label class="text-input-label" [for]="idRnd">{{label}}</label>
    <mat-form-field appearance="outline">
        <input (focus)="yearDatePicker.open()" [matDatepicker]="yearDatePicker" class="lo_sensitive"
            [formControl]="control" autocomplete="bday" [id]="idRnd" matInput [min]="min" [max]="max" />
        <mat-datepicker-toggle [for]="yearDatePicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #yearDatePicker [startAt]="startAt" startView="multi-year"
            (yearSelected)="chosenYearHandler($event, yearDatePicker)"
            panelClass="year-date-picker">
        </mat-datepicker>
        <mat-error *ngIf="control.hasError('required')">
            Required
        </mat-error>
        <mat-error *ngIf="control.hasError('matDatepickerMin') || control.hasError('matDatepickerMax') ">
            Please enter a valid date
        </mat-error>
    </mat-form-field>
</div>